/* libs */
import { createLogic } from "redux-logic";
/* action helpers */
import * as ActionTypes from "../../actions/actionTypes";
import * as ThemesActions from "../../actions/themesActions";

const createThemesFailureLogic = createLogic({
	type: ActionTypes.DELETE_THEME_SUCCESS,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		dispatch(ThemesActions.getThemes(action.appKey));
		done();
	},
});

export default [createThemesFailureLogic];
